import React, { useEffect, useState } from "react";
import ConfirmModal from "../ui/ConfirmModal";
import {
  canPromptInstall,
  isIosSafari,
  isStandalone,
  promptInstall,
  subscribeInstallPrompt,
} from "../../utils/pwa";

/**
 * "Install app" button. Shows only when the browser can install Sportifide
 * (Chrome/Edge/Android), or on iPhone Safari where it explains Add to Home
 * Screen. Hidden once the app runs installed.
 */
const InstallAppButton = ({ className = "floating-nav-btn", label = "Install app" }) => {
  const [available, setAvailable] = useState(canPromptInstall());
  const [showIosHelp, setShowIosHelp] = useState(false);

  useEffect(() => subscribeInstallPrompt(setAvailable), []);

  if (isStandalone()) return null;
  const ios = isIosSafari();
  if (!available && !ios) return null;

  const onClick = () => {
    if (available) {
      promptInstall();
    } else {
      setShowIosHelp(true);
    }
  };

  return (
    <>
      <button type="button" className={className} onClick={onClick} title="Install Sportifide on this device">
        <span className="nav-icon">📲</span>
        {label}
      </button>
      <ConfirmModal
        isOpen={showIosHelp}
        title="📲 Install Sportifide"
        message="Tap the Share button in Safari, then Add to Home Screen. Sportifide opens full screen like an app."
        confirmText="Got it"
        hideCancel
        onConfirm={() => setShowIosHelp(false)}
        onCancel={() => setShowIosHelp(false)}
      />
    </>
  );
};

export default InstallAppButton;
